import React, { Suspense } from "react"
import { HashRouter as Router } from "react-router-dom"
import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
import { Provider } from "react-redux"
import { ConfigProvider } from "antd"
import zhCN from "antd/lib/locale/zh_CN"
import "./app.less"
import "./components/Layout.less"
// import Util from "@_util/util"
import reducers from "./redux"
import Header from "./components/Header"
import MyRoutes from "./routeConfig"

// let $rootHtml = document.getElementById("rootHtml")

// Util.addEventOnResize(resizeFont)

// function resizeFont() {
//   let fs = Util.getResizeFontSize(300, 640)
//   $rootHtml.style.fontSize = fs + "px"
// }

// resizeFont()

const store = createStore(
  reducers,
  compose(
    applyMiddleware(thunk),
    window.devToolsExtension ? window.devToolsExtension() : (f) => f
  )
)
export default () => {
  return (
    <Suspense fallback={null}>
      <ConfigProvider locale={zhCN}>
        <Provider store={store}>
          <Router>
            <div className="pg-wrap">
              <Header />
              <div className="pg-main">
                <div className="pg-body">
                  <MyRoutes />
                </div>
              </div>
            </div>
          </Router>
        </Provider>
      </ConfigProvider>
    </Suspense>
  )
}
